module.exports = __webpack_public_path__ + "media/svg/youtube-b8bbfc84.svg";